/**
 * Entity — base entity (ESM, ha/440).
 *
 * Conversion namespace→ESM. La méthode `resolveControllerNamespace(name)` du
 * legacy faisait du dispatch par switch hard-codé sur trois objets-namespace
 * globaux (`HA.Core.Controller.Navigation` / `Menu` / `Page`). En ESM ces
 * objets n'existent pas → le switch est **supprimé** au profit du
 * `ControllerRegistry` (ha/440). Les controllers s'enregistrent eux-mêmes au
 * top-level de leur module ; `Entity.App` (sous-classe) résout par le registre.
 *
 * Conséquence visible : le paramètre `controllerNamespace` du JSON SSR n'est
 * plus lu — seul `controllerName` compte (le registre est plat). Compat
 * legacy : si un appelant passait encore un namespace via `createService`,
 * la fonction legacy `HA.createService` reste exportée dans HA.ts (ha/441
 * supprimera les derniers call-sites puis cette fonction).
 */

import { HAObject } from "../HAObject";

// Note ha/440 : le slot `registerServiceManager` est exposé par HAObject
// (cycle ESM cassé). ha/441 portera `ServiceManager` (hors-scope ici) qui
// s'enregistrera au top-level — Entity ne touche pas à ce câblage.

export class Entity extends HAObject {

    public static genId(): string {
        return "ID" + Entity.getUUId();
    }

    public static getUUId(): string {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public setId(id: any): Map<string, any> {
        return this.addToData("id", id);
    }

    public getId(): any {
        return this.get("id") || this.get("_id");
    }

    protected initialize(data?: any): void {
        super.initialize(data);
        if (!this.getId()) {
            this.setId(Entity.genId());
        }
    }
}
